/**
 * PNG Compressor - /image/png page
 */
import { createApp } from 'vue';
import PngCompressor from '@/Components/PngCompressor.vue';
import '@styles/app.css';

createApp(PngCompressor).mount('#png-compressor');
